<template>
  <div id="app" class="rotateDiv">

    <b-table striped hover small bordered :items="parujHrace" :fields="parujFields"></b-table>

    <b-form-group label="Vyberte :">
      <b-form-checkbox-group
        id="checkbox-group-1"
        size="lg"
        v-model="parujVybrane"
        :options="parujHrace"
      ></b-form-checkbox-group>
    </b-form-group>

    <b-modal id="modal-change-users" hide-footer>
      <template #modal-title>
        Zadejte hráče
      </template>
      <div class="d-block text-center">
        <div>Napište 3 až 12 hráčů oddělelených mezerou</div>
        <div class="alert alert-danger" v-if="modalErrorMessage.length !== 0">{{ modalErrorMessage}}</div>
        <input v-model="modalTextUsers" ref="inputTextUsers" class="w-100 form-control">
      </div>
      <b-button variant="info" class="mt-3" block @click="changeUsers()">Změnit</b-button>
    </b-modal>

    <div v-if="parujVybrane.length != 0" class="mt-3">Vybraní: <strong>{{ showNamesSelected(parujVybrane) }}</strong></div>

    <div class="alert alert-danger" v-if="errorMessage.length !== 0">{{ errorMessage}}</div>

    <b-sidebar id="sidebar-log" aria-labelledby="sidebar-no-header-title" backdrop shadow width=600px>
      <template >
        <div class="p-3">
          <b-table striped small hover :items="arrLogText" :fields="arrLogTextDefault" ></b-table>
        </div>
      </template>
    </b-sidebar>

    <b-button-group class="mt-10">
      <b-button variant="success" :disabled="!canAddResult" @click="addResult(KONSTANTA.PRIDAT_JEDEN)">Přidat</b-button>
      <b-button variant="success" :disabled="!canAddResult" @click="addResult(KONSTANTA.PRIDAT_DVA)">Přidat DOUBLE</b-button>
      <b-button variant="info" @click="endTurn()">Uzavřít kolo</b-button>

      <b-button variant="success" class="ml-2" :disabled="!haveHistorie" @click="stepBack()">Krok zpět</b-button>

      <b-button variant="success" class="ml-2" @click="openSetHraci()">Změnit seznam hráčů</b-button>
      
      <b-button variant="info" class="ml-2" v-b-toggle.sidebar-log>Log</b-button>
    </b-button-group>

    <div class="w-100 text-center mt-2">
      Popis hry <a href="https://www.zatrolene-hry.cz/spolecenska-hra/kdo-paruje-vyhrava-8186/" target="_blank">Kdo páruje vyhrává</a>
    </div>

    <div class="w-100 text-center mt-2">
      <a href="http://www.mecoun.cz/" target="_blank">Vytvořil LKC</a>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'parovani',
    components: {
    },
    data: function () {
      return {
        KONSTANTA: {
          PRIDAT_JEDEN: 1,
          PRIDAT_DVA: 2,
          MIN_HRACU: 3,
          MAX_HRACU: 12,
        },
        fieldsDefault: [
          { key: 'jmeno',  label: 'Jméno' },
          { key: 'kolo_1', label: 'Kolo 1' },
          { key: 'celkem', label: 'Celkem', variant: 'danger', sortable: true }
        ],
        arrLogTextDefault: [
          { key: 'krok',  label: 'Krok' },
          { key: 'popis', label: 'Popis' }
        ],
        // seznam kol
        parujFields: [],
        // seznam vybranych hracu
        parujVybrane: [],
        // seznam vsech hracu
        parujHrace: [],
        // aktualni kolo
        parujKolo: 1,
        // historie
        parujHistorie: [],
        errorMessage: "",

        // pole pro zadani seznamu hracu
        modalTextUsers: "",
        modalErrorMessage: "",
        // pole logovanych zprav
        arrLogText: []
      }
    },
    computed: {
      haveHistorie: function () {
        // prvni prvek je aktualni stav
        return this.parujHistorie.length > 1
      },
      canAddResult: function() {
        return this.parujVybrane.length > 1
      },
    },
    mounted: function () {
      // zjistime, zda mame ulozne hrace
      let data = localStorage.getItem("kdoparuje_data")
      if (data !== null) {
        // nacteme do formulare
        this.parseData(data)
        // a pridame jako prvni krok do historie
        this.parujHistorie.push(data)
      }
    },
    methods: {
      /* nastavi pocet hracu */
      changeUsers: function () {
        // rozsekame
        let tmpUsers = this.modalTextUsers.split(' ')
        // vyhazeme mezery
        tmpUsers = tmpUsers.filter(word => word.length != 0)

        // otestujem 
        if (tmpUsers.length < this.KONSTANTA.MIN_HRACU || tmpUsers.length > this.KONSTANTA.MAX_HRACU) {
          this.modalErrorMessage = "Počet hráčů [" + tmpUsers.length + "] musí být v intervalu " 
						+ this.KONSTANTA.MIN_HRACU + " - " + this.KONSTANTA.MAX_HRACU + "."
          return
        }
        // vymazeme error
        this.modalErrorMessage = ""

        // vymezeme a pridame
        this.resetUsers()
        for (let newUser of tmpUsers) {
          this.parujHrace.push({ jmeno: newUser, text: newUser, value: this.parujHrace.length, kolo_1: 0, celkem: 0 })
        }

        // a ulozime
        this.saveData()

        // zalogujeme
        this.logText('Vytvořena nová hra pro hráče: ' + this.showNames(this.parujHrace))

        // nakonec zavreme okno
        this.$bvModal.hide('modal-change-users')
      },
      /** Otevre zadani hracu */
      openSetHraci() {
        this.$bvModal.show('modal-change-users') 
        // TODO nefunguje
        // this.$refs.inputTextUsers.focus()
      },
      /** Prida vysledek */
      addResult: function (amount) {
        // zkontrolujeme
        if (this.parujVybrane.length < 2) {
          this.errorMessage = 'Musíte zadat alespoň dva hráče'
          return
        }
        // vymazeme error
        this.errorMessage = ''

        // pridame kolo
        for (let hrac of this.parujHrace) {
          for (let sel of this.parujVybrane) {
            if (sel === hrac.value) {
              hrac["kolo_" + this.parujKolo] += amount*this.parujVybrane.length
              hrac.celkem += amount*this.parujVybrane.length
            }
          }
        }

        // a ulozime
        this.saveData()

        this.logText((amount == 1 ? 'Přidán 1 bod' : 'Přidány ' + amount + ' body') + ' pro ' + this.showNamesSelected(this.parujVybrane))

        // vynulujeme vybrane
        this.parujVybrane = []
      },
      /** Ukonci kolo */
      endTurn: function () {
        // pridame sloupecId 
        this.parujKolo++
      
        // pridame sloupec
        for (let hrac of this.parujHrace) {
          hrac["kolo_" + this.parujKolo] = 0
        }
        // a hlavicku
        this.parujFields.push({ 
          key: 'kolo_' + this.parujKolo,
          label: 'Kolo ' + this.parujKolo,
        })
        // posuneme pred sloupec CELKEM
        this.move(this.parujFields, this.parujKolo, this.parujKolo + 1)

        // a ulozime
        this.saveData()

        this.logText('Ukončeno ' + (this.parujKolo - 1) + '. kolo')
      },
      /** Vrati se o krok zpatky */
      stepBack: function () {
        // odstranime aktualni stav
        this.parujHistorie.pop()
        // dotahneme        
        let backStep = this.parujHistorie[this.parujHistorie.length - 1]
        this.parseData(backStep)

        // a ulozime
        localStorage.setItem("kdoparuje_data", this.generData())

        this.logText('Vrácen poslední krok', true)
      },

//-- Ostatni metody

      resetUsers: function () {
        // vynulujem pole useru
        this.parujHrace = []
        // a hlavicky
        this.parujFields = [...this.fieldsDefault]
        // vynulujeme vybrane
        this.parujVybrane = []
        // a historii
        this.parujHistorie = []
        // reset
        this.arrLogText = []
        this.parujKolo = 1
      },
      /** Vypise jmena vybranych - dle ID*/
      showNamesSelected: function (tmpSelected) {
        let sRes = ""
        for (let sel of tmpSelected) {
          for (let hrac of this.parujHrace) {
            if (sel === hrac.value) {
              sRes += (sRes == "" ? "" : ", ") + hrac.jmeno
            }
          }
        }
        return sRes
      },
      /** Vypise jmena vybranych */
      showNames: function (tmpArray) {
        let sRes = ""
        for (let hrac of tmpArray) {
          sRes += (sRes == "" ? "" : ", ") + hrac.jmeno
        }
        return sRes
      },
      /** Presune prvek v poli */
      move: function (input, from, to) {
        let numberOfDeletedElm = 1
        const elm = input.splice(from, numberOfDeletedElm)[0]
        numberOfDeletedElm = 0
        input.splice(to, numberOfDeletedElm, elm)
      },
      /** Prevede data formulare do JSON */
      parseData: function (data) {
        let dataJSON = JSON.parse(data)
        this.parujFields    = dataJSON.parujFields
        this.parujHrace     = dataJSON.parujHrace
        this.parujKolo      = dataJSON.parujKolo
        this.modalTextUsers = dataJSON.modalTextUsers
      },
      /** Vytahne data formulare z JSON */
      generData: function () {
        let data = JSON.stringify({
           parujFields:     this.parujFields,
           parujHrace:      this.parujHrace,
           parujKolo:       this.parujKolo,
           modalTextUsers:  this.modalTextUsers,
        })
        return data
      },
      /* Ulozi data pro pozdejsi pouziti */
      saveData: function () {
        let data = this.generData()
        localStorage.setItem("kdoparuje_data", data)
        this.parujHistorie.push(data)
      },
      /* Zaloguje akci  */
      logText: function (text, danger) {
        const newItem = { krok: this.arrLogText.length + 1, popis: text }
        if (danger) {
          newItem._rowVariant = 'danger'
        }
        this.arrLogText.unshift(newItem)
      }
    }    
  }
</script>

<style>
  /** zajisti vzdy otocenou obrazovku - https://css-tricks.com/snippets/css/orientation-lock/ */
  @media screen and (orientation: portrait) {
    html {
      transform: rotate(-90deg);
      transform-origin: left top;
      width: 100vh;
      overflow-x: hidden;
      position: absolute;
      top: 100%;
      left: 0;
    }
  }

  .rotateDiv {
/*    transform: rotate(-90deg); */
    padding: 1rem;
  }

  .rowClass {
    background-color: white;
  }

  .btn-primary {
    background-color: #9fa9b3;
    border-color: #afbac5;
  }
</style>